module.exports = __webpack_public_path__ + "img/16.3174fd66.jpg";